import React, { FC } from 'react'
import clsx from 'classnames'
import { Text } from '@/shared/ui'
import style from './searchItem.module.scss'

export const SearchItemSkeleton = () => {
  return (
    <div className={style.searchResultItem}>
      <div className={clsx(style.text, 'skeleton')} />
      <div className={style.secondRow}>
        <span className="skeleton" />

        <Text className={style.text} color={'dark-040'} type="d">
          <span className="skeleton" />
        </Text>
      </div>
    </div>
  )
}
